import { render, staticRenderFns } from "./evento-ficha.vue?vue&type=template&id=96f337d0&scoped=true"
import script from "./evento-ficha.vue?vue&type=script&lang=js"
export * from "./evento-ficha.vue?vue&type=script&lang=js"
import style0 from "./evento-ficha.vue?vue&type=style&index=0&id=96f337d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f337d0",
  null
  
)

export default component.exports